import * as ApiKey from 'types/User/Admin/UserApiKey/UserApiKey';

export type Type = ApiKey.Type[];

export function create(): Type {
	return [];
}

export function changeName(
	apiKeyList: Type,
	input: {
		apiKeyId: string;
		name: string;
	}
): Type {
	return apiKeyList.map((e) => (e.id === input.apiKeyId ? ApiKey.changeName(e, input.name) : e));
}

export function changeSecretKey(
	apiKeyList: Type,
	input: {
		apiKeyId: string;
		secretKey: string;
	}
): Type {
	return apiKeyList.map((e) =>
		e.id === input.apiKeyId ? ApiKey.changeSecretKey(e, input.secretKey) : e
	);
}

export async function generateApiKey(list: Type, apiKey: ApiKey.Type): Promise<Type> {
	return [...list, await ApiKey.generateToApi(apiKey)];
}

export async function saveApiKey(apiKeys: Type, apiKey: ApiKey.Type): Promise<Type> {
	const output: Type = [];
	for (const key of apiKeys) {
		if (key.id !== apiKey.id) {
			output.push(key);
			continue;
		}
		const newKey = await ApiKey.saveToApi(apiKey);
		output.push(newKey);
	}
	return output;
}

export function removeNewApiKeys(apiKeys: Type): Type {
	return apiKeys.filter((e) => e.id !== 'new');
}
